let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("axhr4")).then(() => parcelRequire('h0DlA'));